<script setup lang="ts">
import type {HTMLAttributes} from 'vue'
import {ToastDescription} from 'reka-ui'
import {cn} from '@/lib/utils'

const props = defineProps<{class?: HTMLAttributes['class']}>()
</script>

<template>
  <ToastDescription :class="cn('text-sm text-muted-foreground', props.class)"><slot /></ToastDescription>
</template>
